<template>
  <section class="selected-test-preview" id="toxicology-tests-preview">
    <div class="vue-tabs">
      <el-tabs v-if="getToxicActiveTab">
        <el-tab-pane v-if="showTab('TOXICOLOGY', ['SCREENING', 'SCREENING_VALIDITY'])">
          <template #label>
            <div class="custom-tabs-label">
              <span @click="showScreenTests"> Screening </span>
              <el-button class="custom-tab-close-btn" @click="removeTab"
                v-if="notCreateCase && isBillingUser && !isReleasePending" :disabled="hasCases">
                <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
              </el-button>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane v-if="
          showTab(
            'TOXICOLOGY',
            ['SCREENING', 'ETG_ETS','ETG/ETS', 'SCREENING_VALIDITY', 'D_L_Isomer','ORAL_FLUID_TOX_CONFIRMATION','ORAL_FLUID_TOX_CONFIRMATION_SCREENING','ORAL_FLUID_TOX_SCREENING'],
            false
          )
        ">
          <template #label>
            <div class="custom-tabs-label">
              <span @click="showConfirmationTests"> Confirmation </span>
              <el-button class="custom-tab-close-btn" @click="removeConfirmationTab"
                v-if="notCreateCase && isBillingUser && !isReleasePending" :disabled="hasCases">
                <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
              </el-button>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane v-if="showTab('TOXICOLOGY', ['ETG_ETS','ETG/ETS'])">
          <template #label>
            <div class="custom-tabs-label">
              <span @click="showEtgEtsTests"> ETG/ETS </span>
              <el-button class="custom-tab-close-btn" @click="removeEtgTab"
                v-if="notCreateCase && isBillingUser && !isReleasePending" :disabled="hasCases">
                <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
              </el-button>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane v-if="showTab('TOXICOLOGY', ['D_L_Isomer'])">
          <template #label>
            <div class="custom-tabs-label">
              <span @click="showDLIsomer"> D & L Isomer</span>
              <el-button class="custom-tab-close-btn" @click="removeDLIsomerTab"
                v-if="notCreateCase && isBillingUser && !isReleasePending" :disabled="hasCases">
                <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
              </el-button>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane v-if="showTab('TOXICOLOGY', ['ORAL_FLUID_TOX_CONFIRMATION','ORAL_FLUID_TOX_CONFIRMATION_SCREENING','ORAL_FLUID_TOX_SCREENING'])">
          <template #label>
            <div class="custom-tabs-label">
              <span @click="showOralFluidTests">Oral Fluid Tox</span>
              <el-button class="custom-tab-close-btn" @click="removeOralFluidTab"
                v-if="notCreateCase && isBillingUser && !isReleasePending" :disabled="hasCases">
                <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
              </el-button>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="default-modal" v-if="screeningTestsPopup">
      <el-dialog v-model="screeningTestsPopup">
        <div class="dialog-header">
          <span class="header-part">Screening</span>
          <el-button size="medium" class="el-white" type="info" plain @click="screeningTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li class="toxicology-text-panels" v-for="(category, index) of getFilteredCategories(
              test.case_type_code,
              ['SCREENING', 'SCREENING_VALIDITY'], 'include')" :key="index">
              <h3 class="test-group-title">{{ category.panel_title }}</h3>
              <ul class="check-list-woundpanel">
                <li v-for="(item, index) of sortedCategoryWiseTestsData(
                  category
                )" :key="index">
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
    <div class="default-modal" v-if="confirmationTestsPopup">
      <el-dialog v-model="confirmationTestsPopup">
        <div class="dialog-header">
          <span class="header-part">Confirmation</span>
          <el-button size="medium" class="el-white" type="info" plain @click="confirmationTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">

          <ul>
            <li class="toxicology-text-panels" v-for="(category, index) of getFilteredCategories(
              test.case_type_code,
              ['SCREENING', 'ETG_ETS','ETG/ETS', 'SCREENING_VALIDITY', 'D_L_Isomer','ORAL_FLUID_TOX_CONFIRMATION','ORAL_FLUID_TOX_SCREENING','ORAL_FLUID_TOX_CONFIRMATION_SCREENING'],
              'exclude'
            )" :key="index">
              <h3 class="test-group-title">{{ category.panel_title }}</h3>
              <ul class="check-list-woundpanel">
                <li v-for="(item, index) of sortedCategoryWiseTestsData(
                  category
                )" :key="index">
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
    <div class="default-modal" v-if="etgetsTestsPopup">
      <el-dialog v-model="etgetsTestsPopup">
        <div class="dialog-header">
          <span class="header-part">ETG/ETS</span>
          <el-button size="medium" class="el-white" type="info" plain @click="etgetsTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul class="check-list-check-list-default">
            <li class="toxicology-text-panels" v-for="(category, index) of getFilteredCategories(
              test.case_type_code,
              ['ETG_ETS','ETG/ETS'],
              'include'
            )" :key="index">
              <h3 class="test-group-title">
                {{ category.panel_title }}
              </h3>
              <ul class="check-list-toxicology">
                <li v-for="(item, index) of sortedCategoryWiseTestsData(
                  category
                )" :key="index">
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
    <div class="default-modal" v-if="dlIsomerTestsPopup">
      <el-dialog v-model="dlIsomerTestsPopup">
        <div class="dialog-header">
          <span class="header-part">D & L Isomer</span>
          <el-button size="medium" class="el-white" type="info" plain @click="dlIsomerTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li class="toxicology-text-panels" v-for="(category, index) of getFilteredCategories(
              test.case_type_code,
              ['D_L_Isomer'],
              'include'
            )" :key="index">
              <h3 class="test-group-title">{{ category.panel_title }}</h3>
              <ul class="check-list-woundpanel">
                <li v-for="(item, index) of sortedCategoryWiseTestsData(
                  category
                )" :key="index">
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
    <div class="default-modal" v-if="oralFluidTestsPopup">
      <el-dialog v-model="oralFluidTestsPopup">
        <div class="dialog-header">
          <span class="header-part">Oral Fluid Tox</span>
          <el-button size="medium" class="el-white" type="info" plain @click="oralFluidTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li class="toxicology-text-panels" v-for="(category, index) of getFilteredCategories(
              test.case_type_code,
              ['ORAL_FLUID_TOX_CONFIRMATION', 'ORAL_FLUID_TOX_CONFIRMATION_SCREENING', 'ORAL_FLUID_TOX_SCREENING'],
              'include'
            )" :key="index">
              <h3 class="test-group-title">{{ category.panel_title }}</h3>
              <ul class="check-list-woundpanel">
                <li v-for="(item, index) of sortedCategoryWiseTestsData(
                  category
                )" :key="index">
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import { mapGetters } from "vuex";
export default {
  mixins: [UserPermissionsHelper],
  props: ["panelTestsData", "test", "allSelectedTests", "newCase"],
  data() {
    return {
      toxicTestsLoading: false,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: []
      },
      allTests: "",
      caseRouteNames: [
        "NewCase",
        "Case-Information-Update",
        "NewOrder",
        "Edit-Order-Info",
        "PendingCasesEdit",
        "Concurrent-Case-Information-Update",
      ],
      screeningTestsPopup: false,
      confirmationTestsPopup: false,
      etgetsTestsPopup: false,
      dlIsomerTestsPopup: false,
      oralFluidTestsPopup:false
    };
  },
  async mounted() {
    this.panelsTestsData = this.panelTestsData;
    this.allTests = this.allSelectedTests;

    // WE NEED TO APPEND PANEL CODE TO PANEL 

    this.panelsTestsData.selectedCategories = this.panelsTestsData.selectedCategories.map((e) => {

      e.panel_code = this.getPanelCodeByPanelId(e.panel_id)
      return e;
    })
    this.toxicTestsLoading = true;
    this.toxicTestsLoading = false;
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    hasCases() {
      if (this.checkUser && !this.hasAllowedCaseType && !this.newCase) {
        return true;
      } else if (this.checkUser && this.hasAllowedCaseType && this.newCase) {
        return true;
      }
      return false;
    },
    checkUser() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        return true;
      }
      return false;
    },
    hasAllowedCaseType() {
      if (
        this.getAuthenticatedUser.allowed_case_types &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.length
        ) {
          const cases = this.getCaseInformation.case_types;
          const casetypes = this.getAuthenticatedUser.allowed_case_types;

          if (cases.every((item) => casetypes.includes(item))) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    ...mapGetters("cases", ["getCaseInformation"]),
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }
      return data;
    },
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    getToxicActiveTab() {
      let toxic = this.selectedTestsDetails.filter(
        (x) => x.case_type_code == "TOXICOLOGY"
      );

      if (toxic.length) {
        let screeningFound = toxic.find(
          (test) => test.panel_title.indexOf("Screening") > -1
        );
        let confirmationFound = toxic.find(
          (test) =>
            test.panel_title.indexOf("Screening") == -1 &&
            test.panel_title.indexOf("ETG/ETS") == -1
        );
        let etgEtsFound = toxic.find(
          (test) => test.panel_title.indexOf("ETG/ETS") > -1
        );

        if (screeningFound) {
          return "screening";
        } else if (confirmationFound) {
          return "confirmation";
        } else if (etgEtsFound) {
          return "ETG/ETS";
        }
      }

      return "screening";
    },
    notCreateCase() {
      if (this.caseRouteNames.indexOf(this.$route.name) != -1) {
        return true;
      }
      return false;
    }
  },
  methods: {
    showOralFluidTests() {
      this.oralFluidTestsPopup = true;
    },
    showDLIsomer() {
      this.dlIsomerTestsPopup = true;
    },
    showScreenTests() {
      this.screeningTestsPopup = true;
    },
    showConfirmationTests() {
      this.confirmationTestsPopup = true;
    },
    showEtgEtsTests() {
      this.etgetsTestsPopup = true;
    },
    removeTab() {
      let screening = ["SCREENING", "SCREENING_VALIDITY"];

      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"SCREENING"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        let testIndex = this.panelsTestsData.selectedCategories.findIndex((e) => e.panel_code == "SCREENING")
        this.panelsTestsData.selectedCategories.splice(testIndex, 1)
        // Emit event to parent to refresh test tube information
        this.$emit('refresh-test-tubes');
      });
    },
    getPanelCodeByPanelId(id) {
      return this.getNewLabGroupPanelTests.find((e) => e.panel_id == id)?.panel_code
    },

    removeConfirmationTab() {
      let nonConfirmation = ["SCREENING", "ETG_ETS","ETG/ETS", "SCREENING_VALIDITY", "D_L_Isomer","ORAL_FLUID_TOX_CONFIRMATION"];

      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"CONFIRMATION"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        this.panelsTestsData.selectedCategories = this.panelsTestsData.selectedCategories.filter((panel, index) => {
          if (nonConfirmation.indexOf(panel.panel_code) > -1) {
            return true;
          }
        })
        // Emit event to parent to refresh test tube information
        this.$emit('refresh-test-tubes');
      });
    },
    removeEtgTab() {
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"ETG/ETS"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        let testIndex = this.panelsTestsData.selectedCategories.findIndex((e) => e.panel_code == "ETG_ETS" || e.panel_code == "ETG/ETS")
        this.panelsTestsData.selectedCategories.splice(testIndex, 1)
        // Emit event to parent to refresh test tube information
        this.$emit('refresh-test-tubes');
      });
    },
    removeDLIsomerTab() {
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"D & L Isomer"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        let testIndex = this.panelsTestsData.selectedCategories.findIndex((e) => e.panel_code == "D_L_Isomer")
        this.panelsTestsData.selectedCategories.splice(testIndex, 1)
        // Emit event to parent to refresh test tube information
        this.$emit('refresh-test-tubes');
      });
    },
    removeOralFluidTab() {
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"Oral Fluid Tox Confirmation"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        let testIndex = this.panelsTestsData.selectedCategories.findIndex((e) => e.panel_code == "ORAL_FLUID_TOX_CONFIRMATION")
        this.panelsTestsData.selectedCategories.splice(testIndex, 1)
        // Emit event to parent to refresh test tube information
        this.$emit('refresh-test-tubes');
      });
    },
    getCategoryWiseTestsData(caseType, category) {
      const data = this.getNewLabGroupPanelTests.filter(
        (el) => el.case_type_code === caseType && el.panel_code === category
      );
      return data;
    },

    sortedCategoryWiseTestsData(category) {
      let selectedCategory = this.panelsTestsData.selectedCategories.find(
        (e) => e.panel_id == category.panel_id
      );

      if (!selectedCategory) {
        return [];
      }

      return this.getCategoryWiseTestsData(
        category.case_type_code,
        category.panel_code
      )
        .filter((test) => selectedCategory.test_ids.includes(test._id))
        .sort((a, b) => {
          return a.test_name.localeCompare(b.test_name);
        });
    },
    showTab(caseType, category, include = true) {
      if (include) {
        return this.panelsTestsData.selectedCategories.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) != -1
        ).length
          ? true
          : false;
      } else {
        return this.panelsTestsData.selectedCategories.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) == -1
        ).length
          ? true
          : false;
      }
    },

    // for toxicology


    getCaseCategoryData(caseType) {
      let selectedTestPanelIds = this.panelsTestsData.selectedCategories.map(
        (e) => e.panel_id
      );

      let data = this.getNewLabGroupPanelTests.filter((e) =>
        selectedTestPanelIds.includes(e.panel_id)
      );

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },

    getFilteredCategories(caseType, categories, includeType) {
      let data = [];

      if (includeType == "include") {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code &&
            el.case_type_code === caseType &&
            categories.includes(el.panel_code)
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code &&
            el.case_type_code === caseType &&
            !categories.includes(el.panel_code)
        );
      }

      let selectedTestPanelIds = this.panelsTestsData.selectedCategories.map(
        (e) => e.panel_id
      );

      data = data.filter((e) =>
        selectedTestPanelIds.includes(e.panel_id)
      );

      data = data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      return data;
    },


    getCaseCategoryBasedData(caseType, category, include = true) {

      let selectedTestPanelIds = this.panelsTestsData.selectedCategories.map(
        (e) => e.panel_id
      );

      let data = this.getNewLabGroupPanelTests.filter((e) =>
        selectedTestPanelIds.includes(e.panel_id)
      );


      if (include) {
        data = this.panelTestsData.selectedCategories.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) != -1
        );
      } else {
        data = this.panelTestsData.selectedCategories.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) == -1
        );
      }

      data = data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      return data;
    },

    updateTestsPanelsData(event) {
      this.loading = true;
      if (event.data) {
        this.panelsTestsData.selectedTestIds = event.data.selectedTestIds;
        this.panelsTestsData.selectedCategories = event.data.selectedCategories;
        this.panelsTestsData.selectedGroup = event.data.selectedGroup;
        this.allTests = event.allTests;
      }

      setTimeout(() => {
        this.loading = false;
      }, 500);
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss">
.test-panels-blocks {
  .toxicology-text-panels {
    padding: 10px 0;
    position: relative;
  }

  .toxicology-text-panels:not(:last-child):after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    border-bottom: 1px solid #e8e4e4;
  }

  .check-list-toxicology {
    display: grid;
    grid-template-columns: repeat(5, 19%);
    -moz-column-gap: 10px;
    column-gap: 10px;

    li {
      margin: 7px 0;

      &:not(:last-child) {
        margin-right: 15px;
      }
    }

    .el-checkbox {
      height: auto;
    }

    .el-checkbox-group {
      .el-checkbox {
        height: 20px;
      }

      .el-checkbox__input .el-checkbox__inner {
        border-color: transparent;
        box-shadow: 0 0 0 1px #ced1d6;
        border-radius: 4px;
        width: 17px;
        height: 17px;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #273480;
        border-color: #ffffff;
        box-shadow: 0 0 0 1px #ced1d6;
        width: 17px;
        height: 17px;
      }

      .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 2px solid var(--el-checkbox-checked-icon-color);
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(1);
        width: 3px;
        transition: transform 0.15s ease-in 50ms;
        transform-origin: center;
      }

      .el-checkbox__label {
        color: #34495e;
      }
    }
  }

  .test-group-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 5px;
  }
}
</style>
